const axios = require('axios');

const ENV = process.env;

export default class WatermarkService {
  static returnDefaultValues() {
    return {
      watermark_scale: '15',
      watermark_position_x: 'right',
      watermark_position_y: 'bottom',
      watermark: null,
    };
  }

  /**
   * CRUD
   */

  static getWatermarks() {
    const accessToken = localStorage.getItem('access_token');
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;

    return new Promise(function (resolve, reject) {
      axios({
        method: 'GET',
        url: ENV.api + '/watermarks/',
      })
        .then(function (data) {
          resolve(data);
        })
        .catch(function (data) {
          reject(data);
        });
    });
  }

  static getWatermark(id) {
    return new Promise(function (resolve, reject) {
      axios({
        method: 'get',
        url: ENV.api + '/watermarks/' + id,
      })
        .then(function (data) {
          resolve(data);
        })
        .catch(function (data) {
          reject(data);
        });
    });
  }

  static addWatermark(data) {
    return new Promise(function (resolve, reject) {
      axios({
        method: 'POST',
        url: ENV.api + '/watermarks/',
        headers: { 'Content-Type': undefined },
        data: data,
      })
        .then(function (data) {
          resolve(data);
        })
        .catch(function (data) {
          reject(data);
        });
    });
  }

  static deleteWatermark(id) {
    const accessToken = localStorage.getItem('access_token');
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;
    return new Promise(function (resolve, reject) {
      axios({
        method: 'delete',
        url: ENV.api + '/watermarks/' + id,
      })
        .then(function (data) {
          resolve(data);
        })
        .catch(function (data) {
          reject(data);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/watermark.es6.js